import { IError } from '../base/error'
import ServiceBase from '../base/service.base'
import { IBrandProvider } from '../company/company.types'

import { IBrandsResponseDTO } from './brand.types'

export class Brand extends ServiceBase {
  public async getBrandsProviders(
    startDate?: string,
    endDate?: string,
  ): Promise<IBrandProvider[]> {
    const url = `/brand/providers`

    const response = await this.request.get<IBrandProvider[], IError>(url, {
      params: {
        from: startDate || undefined,
        to: endDate || undefined,
      },
    })

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  /**
   * Return the brands of a user company.
   * @returns object with jwt
   */
  public async getBrands(): Promise<IBrandsResponseDTO[]> {
    const url = '/brand'

    const response = await this.request.get<IBrandsResponseDTO[], IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  /**
   * Return the brands of a user company ecossytem (branch -> head relations).
   * @returns object with jwt
   */
  public async getBrandsBranched(): Promise<IBrandsResponseDTO[]> {
    const url = '/brand/branched'

    const response = await this.request.get<IBrandsResponseDTO[], IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
